import { render, staticRenderFns } from "./AttendeesListItem.vue?vue&type=template&id=781552c5"
import script from "./AttendeesListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendeesListItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports